
export default {
	columns: {
		orderTitle: {
			label: '订单商品',
			visible: true,
			width: 'auto',
			align: 'left',
		},
		orderStatusCn: {
			label: '订单状态',
			visible: true,
			width: '100',
			align: 'left',
		},
		consumeCode: {
			label: '核销劵码',
			visible: true,
			width: '150',
			align: 'left',
		},
		orderSourceCn: {
			label: '核销渠道',
			visible: true,
			width: '150',
			align: 'left',
		},
		orderAmount: {
			label: '订单金额',
			visible: true,
			width: '100',
			align: 'left',
		},

		oxCtime: {
			label: '支付时间',
			visible: true,
			formatDay: true,
			width: '160',
			align: 'left',
		},
	},
}
